import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getTexts } from './i18n';

const MySwal = withReactContent(Swal);

// Bilgilendirme Popup'ı
export const showInfoAlert = (title: string, text: string) => {
    const texts = getTexts();

    return MySwal.fire({
        title,
        text,
        icon: 'info',
        confirmButtonText: texts.ok,
    });
};

// Başarı Popup'ı
export const showSuccessAlert = (title: string, text: string) => {
    const texts = getTexts();

    return MySwal.fire({
        title,
        text,
        icon: 'success',
        confirmButtonText: texts.amazing,
    });
};

// Hata Popup'ı
export const showErrorAlert = (title: string, text: string) => {
    const texts = getTexts();

    return MySwal.fire({
        title,
        text,
        icon: 'error',
        confirmButtonText: texts.ok,
    });
};

// Onay Kutusu Popup'ı
export const showConfirmAlert = (
    title: string,
    text: string,
    confirmText?: string,
    cancelText?: string
) => {
    const texts = getTexts();

    return MySwal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText || texts.yes,
        cancelButtonText: cancelText || texts.no,
    });
};

// Onay Kutusu Popup'ı 
export const showConfirmAndRedirectAlert = (
    title: string,
    text: string,
    confirmText?: string,
    cancelText?: string,
    redirectUrl?: string // Opsiyonel yönlendirme URL'si
) => {
    const texts = getTexts();

    return MySwal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmText || texts.yes,
        cancelButtonText: cancelText || texts.no,
    }).then((result) => {
        if (result.isConfirmed && redirectUrl) {
            // Onaylanırsa yönlendirme yap
            window.location.href = redirectUrl;
        }
    });
};
